var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkeletonBubbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 176,
    viewBox: "0 0 235 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 65.5849,
    cy: 38.2461,
    rx: 37.5849,
    ry: 36.9687,
    fill: "#A1A2AD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 65.5849,
    cy: 129.246,
    rx: 37.5849,
    ry: 36.9687,
    fill: "#A1A2AD"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 37.5849,
    cy: 75.9688,
    rx: 37.5849,
    ry: 36.9687,
    fill: "#A1A2AD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 158.053,
    cy: 62.3068,
    rx: 35.0454,
    ry: 34.4709,
    fill: "#A1A2AD"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 104.949,
    cy: 29.8686,
    rx: 29.9494,
    ry: 29.4584,
    fill: "#A1A2AD"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 85.4217,
    cy: 144.142,
    rx: 31.49,
    ry: 30.9738,
    fill: "#A1A2AD"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 143.324,
    cy: 129.919,
    rx: 31.49,
    ry: 30.9738,
    fill: "#A1A2AD"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 199.7,
    cy: 109.033,
    rx: 35.0454,
    ry: 34.4709,
    fill: "#A1A2AD"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 105.585,
    cy: 83.2461,
    rx: 37.5849,
    ry: 36.9687,
    fill: "#A1A2AD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonBubbles);
export default __webpack_public_path__ + "static/media/skeleton-bubbles.e69630cd56bd701c034b61d21f1a1e6f.svg";
export { ForwardRef as ReactComponent };